import React from 'react'
import StandardLayout from './StandardLayout'

import { ChildProps } from '~/common/define/props'
import PublicHeader from '~/components/molecules/header/public/PublicHeader'
import PublicFooter from '~/components/atoms/footer/PublicFooter'
import CopyRightFooter from '~/components/atoms/footer/CopyRightFooter'

interface Props extends ChildProps {
  isResponsive?: boolean
  noBackGround?: boolean
}

const PublicLayout = ({children, isResponsive, noBackGround = false}: Props) => {
  return (
    <StandardLayout isResponsive={isResponsive} noBackGround={noBackGround}>
      <PublicHeader/>
        {children}
      <PublicFooter/>
      <CopyRightFooter/>
    </StandardLayout>
  )
}

export default PublicLayout